var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(" ");t.b(t.v( gettext("Подтверждение операции") ));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, " {{ ___1___ }}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/confirm_page_title.html
// module id = 186
// module chunks = 4